import { AcademyMockApi } from 'app/http/apps/academy/api';
import { ChatMockApi } from 'app/http/apps/chat/api';
import { ContactsMockApi } from 'app/http/apps/contacts/api';
import { ECommerceInventoryMockApi } from 'app/http/apps/ecommerce/inventory/api';
import { FileManagerMockApi } from 'app/http/apps/file-manager/api';
import { HelpCenterMockApi } from 'app/http/apps/help-center/api';
import { MailboxMockApi } from 'app/http/apps/mailbox/api';
import { NotesMockApi } from 'app/http/apps/notes/api';
import { ScrumboardMockApi } from 'app/http/apps/scrumboard/api';
import { TasksMockApi } from 'app/http/apps/tasks/api';
import { AuthMockApi } from 'app/http/common/auth/api';
import { MessagesMockApi } from 'app/http/common/messages/api';
import { NavigationMockApi } from 'app/http/common/navigation/api';
import { NotificationsMockApi } from 'app/http/common/notifications/api';
import { SearchMockApi } from 'app/http/common/search/api';
import { ShortcutsMockApi } from 'app/http/common/shortcuts/api';
import { UserMockApi } from 'app/http/common/user/api';
import { AnalyticsMockApi } from 'app/http/dashboards/analytics/api';
import { CryptoMockApi } from 'app/http/dashboards/crypto/api';
import { FinanceMockApi } from 'app/http/dashboards/finance/api';
import { ProjectMockApi } from 'app/http/dashboards/project/api';
import { ActivitiesMockApi } from 'app/http/pages/activities/api';
import { IconsMockApi } from 'app/http/ui/icons/api';

export const mockApiServices = [
    AcademyMockApi,
    ActivitiesMockApi,
    AnalyticsMockApi,
    AuthMockApi,
    ChatMockApi,
    ContactsMockApi,
    CryptoMockApi,
    ECommerceInventoryMockApi,
    FileManagerMockApi,
    FinanceMockApi,
    HelpCenterMockApi,
    IconsMockApi,
    MailboxMockApi,
    MessagesMockApi,
    NavigationMockApi,
    NotesMockApi,
    NotificationsMockApi,
    ProjectMockApi,
    SearchMockApi,
    ScrumboardMockApi,
    ShortcutsMockApi,
    TasksMockApi,
    UserMockApi,
];
